import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TourAnchorDirective } from './tour-anchor.directive';
import { TourOverlayComponent } from './tour-overlay.component';

@NgModule({
  declarations: [TourAnchorDirective, TourOverlayComponent],
  imports: [CommonModule],
  exports: [TourAnchorDirective, TourOverlayComponent]
})
export class TourModule {}
